module.exports = __webpack_public_path__ + "assets/img/w0.0cb2f815.png";